import { render, staticRenderFns } from "./AcessDenied.vue?vue&type=template&id=d248aa9a&scoped=true&"
import script from "./AcessDenied.vue?vue&type=script&lang=js&"
export * from "./AcessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d248aa9a",
  null
  
)

export default component.exports